/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_TitleInputs */

const en_pricing_title = /** @type {(inputs: Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick your plan`)
};

const id_pricing_title = /** @type {(inputs: Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih paketmu`)
};

/**
* | output |
* | --- |
* | "Pick your plan" |
*
* @param {Pricing_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pricing_title = /** @type {((inputs?: Pricing_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pricing_title(inputs)
	return en_pricing_title(inputs)
});